import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Markets from './components/Markets';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Brands from './components/Brands';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-charcoal font-body">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <Markets />
      <Projects />
      <Contact />
      <Brands />
      <Footer />
    </div>
  );
}
